export default __webpack_public_path__ + "static/media/quite-impressed.67071189.ogg";